import './insured-entity-detail-header.scss';

import { Box, Chip, Stack, Typography } from '@mui/material';
import { PaperLayout, PrimaryTitle } from '../../../presentation';

import { convertInputToFormattedAmountUSD } from '@converge/utils';
import { useTranslation } from 'react-i18next';

interface IProps {
  insuredReferenceId?: string | null;
  industrySector?: string | null;
  addressHeader?: string | null;
  insuredHeader?: string | null;
  revenueHeader?: string | null;
  domain?: string | null;
  contact?: string | null;
  projectedRevenue?: string | null;
  activePoliciesCount?: number;
  insuredLogo?: string | null;
}

export const InsuredEntityHeader = ({
  insuredReferenceId,
  industrySector,
  insuredHeader,
  revenueHeader,
  domain,
  contact,
  projectedRevenue,
  activePoliciesCount = 0,
  insuredLogo,
}: IProps) => {
  const { t } = useTranslation();
  const hasActivePolicies = activePoliciesCount > 0;

  return (
    <PaperLayout className="entity-detail-header-layout">
      <div className="entity-detail-header-container-insured">
        <div className="entity-reference-container">
          <div className="entity-id-container">
            <Typography variant="h5" className="entity-id">
              {insuredReferenceId}
            </Typography>
            <Chip
              label={`(${activePoliciesCount}) ACTIVE POLICIES`}
              className={
                hasActivePolicies
                  ? 'active-policies-chip'
                  : 'inactive-policies-chip'
              }
              color={hasActivePolicies ? 'success' : 'error'}
              size="small"
            />
          </div>
        </div>

        <InsuredEntityHeader.Field
          label={t('underwriting.detail.header.insuredLabel', 'INSURED')}
          value={insuredHeader ?? 'N/A'}
        />

        <InsuredEntityHeader.Field
          label={t('underwriting.detail.header.domain', 'DOMAIN')}
          value={domain ?? 'N/A'}
        />

        <InsuredEntityHeader.Field
          label={t('underwriting.detail.header.contact', 'CONTACT')}
          value={contact ?? 'N/A'}
        />

        <InsuredEntityHeader.Field
          label={t(
            'underwriting.detail.header.currentRevenue',
            'CURRENT REVENUE'
          )}
          value={convertInputToFormattedAmountUSD(revenueHeader) ?? 'N/A'}
        />

        <InsuredEntityHeader.Field
          label={t(
            'underwriting.detail.header.projectedRevenue',
            'PROJECTED REVENUE'
          )}
          value={
            projectedRevenue !== 'N/A'
              ? convertInputToFormattedAmountUSD(projectedRevenue)
              : 'N/A'
          }
        />

        <InsuredEntityHeader.Field
          label={t(
            'underwriting.detail.header.industrySector',
            'INDUSTRY SECTOR'
          )}
          value={industrySector ?? 'N/A'}
        />
      </div>
    </PaperLayout>
  );
};

InsuredEntityHeader.Field = ({
  label,
  value,
}: {
  label: string;
  value?: string;
}) => {
  return (
    <Stack className="insured-entity-header-for-field" gap={0.5}>
      <Box>
        <Typography variant="h6" margin={0} lineHeight={'1em'}>
          {label}
        </Typography>
      </Box>
      <Box>
        <PrimaryTitle variant="h5" margin={0} lineHeight={'1em'}>
          {value}
        </PrimaryTitle>
      </Box>
    </Stack>
  );
};
